module.exports = __webpack_public_path__ + "static/img/15.e792cf9.png";


//////////////////
// WEBPACK FOOTER
// ./static/images/products/1/4/2/zh/15.png
// module id = FRw8
// module chunks = 0